import { DefaultPage } from "./"

export default {
  path: "/",
  name: "Home",
  component: DefaultPage,
}



// WEBPACK FOOTER //
// ./src/features/home/route.js